import React from 'react'
import formatDate from '../../../../../../utils/formatDate'

const JobSeekerTraining = ({ data }) => {
  return (
    <div className="candidate-profile my-3 border rounded border-primary">

      <div className="work-experience">
        <div>
          <h5 className="designation">{data["name"]}</h5>
          <p className="company-location">
            <b>Organization: {data["organization"]}</b>
          </p>
          {
            data?.start_date &&
            <p className="tenure">

              {data?.start_date ? formatDate(data.start_date) : ''} - {data?.end_date ? formatDate(data?.end_date) : 'In Progress'}

            </p>
          }
          <p className="description">{data?.description}</p>
        </div>
      </div>

    </div>
  )
}

export default JobSeekerTraining